module.exports = __webpack_public_path__ + "img/Duplicate.ac19d981.svg";